<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>


<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>


<div class="container text-center overflow-hidden">
  <div *ngIf="isEdit && skillTreeId && !isViewOnly">
    <button mat-mini-fab color="warn" class="float-right btn-delete"
      (click)="deleteSkillTree(skillTreeId, skillTreeForm.value.name)">
      <img src=" ../../../../assets/delete.png" style="width: 22px; margin-left: 4px; margin-top: -4px;">
    </button>
  </div>
  <div class="row justify-content-center">
    <div class="col-8">
      <h2 class="lifedi-color text-center">
        Skill Tree
      </h2>
    </div>
  </div>
  <div *ngIf="!isEdit" class="mt-3 mb-2">
    <form [formGroup]="skillTreeForm">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6">
          <div class="form-group row">
            <label for="name" class="col-3 col-form-label">ชื่อ Skill Tree<lifedi-require></lifedi-require></label>
            <div class="col-9">
              <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off"
                ngDefaultControl>
            </div>
          </div>
          <div class="form-group row">
            <label for="teacher" class="col-3 col-form-label">
              อาจารย์<lifedi-require></lifedi-require><br>
            </label>
            <div class="col-9" id="teacher">
              <nz-select #teacher class="text-left col-12" nzMode="multiple" nzPlaceHolder="เลือกอาจารย์"
                formControlName="teachers" [compareWith]="compareFn" [(ngModel)]="skillTreeForm.value.teachers"
                (ngModelChange)="getSelectedItem(teacher.value)" [ngModelOptions]="{standalone: true}">
                <nz-option *ngFor="let teacher of allTeacher" [nzLabel]="teacher.USERNAME"
                  [nzValue]="teacher.TEACHER_ID">
                </nz-option>
              </nz-select>
              <small *ngIf="skillTreeForm.value.teachers.length === 0" class="text-danger" style="float: left;">
                *กรุณาเลือกอาจารย์
              </small>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="isEdit && skillTreeForm" class="mt-3 mb-2">
    <form [formGroup]="skillTreeForm">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6">
          <div class="form-group row">
            <label for="name" class="col-3 col-form-label">ชื่อ Skill Tree<lifedi-require></lifedi-require></label>
            <div class="col-9">
              <input *ngIf="!isViewOnly" type="text" class="form-control" id="name" formControlName="name"
                autocomplete="off" ngDefaultControl>

              <!-- read only -->
              <input *ngIf="isViewOnly" [readonly]="true" type="text" class="form-control" id="name"
                formControlName="name" autocomplete="off" ngDefaultControl>
            </div>
          </div>
          <div class="form-group row">
            <label for="teacher" class="col-3 col-form-label">
              อาจารย์<lifedi-require></lifedi-require><br>
            </label>
            <div class="col-9" id="teacher">
              <!-- [(ngModel)]="skillTreeForm.value.teachers.TEACHER_ID" (ngModelChange)="getSelectedItem(teacher)" -->
              <nz-select *ngIf="!isViewOnly" #teacher class="text-left col-12" nzMode="multiple"
                nzPlaceHolder="เลือกอาจารย์" formControlName="teachers" [compareWith]="compareFn"
                [(ngModel)]="skillTreeForm.value.teachers" (ngModelChange)="getSelectedItem(teacher.value)"
                [ngModelOptions]="{standalone: true}">
                <nz-option *ngFor="let teacher of allTeacher" [nzLabel]="teacher.USERNAME"
                  [nzValue]="teacher.TEACHER_ID">
                </nz-option>
              </nz-select>
              <small *ngIf="skillTreeForm.value.teachers.length === 0 && !isViewOnly" class="text-danger"
                style="float: left;">
                *กรุณาเลือกอาจารย์
              </small>

              <!-- read only -->
              <nz-select *ngIf="isViewOnly" #teacher class="text-left col-12" nzMode="multiple"
                nzPlaceHolder="เลือกอาจารย์" [compareWith]="compareFn" [(ngModel)]="skillTreeForm.value.teachers"
                [nzDisabled]="true" [ngModelOptions]="{standalone: true}">
                <nz-option *ngFor="let teacher of allTeacher" [nzLabel]="teacher.USERNAME"
                  [nzValue]="teacher.TEACHER_ID">
                </nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <lifedi-skill-tree *ngIf="!isEdit" [nodes]="nodes" [clusters]="clusters" [links]="links"></lifedi-skill-tree>
  <lifedi-skill-tree *ngIf="isEdit && nodes && clusters && links" [nodes]="nodes" [clusters]="clusters" [links]="links">
  </lifedi-skill-tree>

  <div *ngIf="!isViewOnly" class="row mt-4 mb-4">
    <div class="offset-1"></div>
    <div *ngFor="let name of level; let i = index;" class="col-2">
      <h5 style="margin-bottom: 15px;"><b>{{name}}</b></h5>
      <div *ngFor="let node of arrNode[name]; let j = index;" class="mb-2">
        <lifedi-btn [lable]="node.label" (click)="editNode(node, i, j, name)" customStyle="background-color: #2D2A4A; color: #FFF; width: 100%; margin: 0px; padding: 0 15px;
          white-space: nowrap; overflow:hidden !important; text-overflow: ellipsis;">
        </lifedi-btn>
      </div>
      <button mat-mini-fab class="img" (click)="createNode(name)"
        [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
      </button>
    </div>
    <div class="offset-1"></div>
  </div>

  <div *ngIf="!isEdit && !isViewOnly">
    <div class="mt-3 mb-3" style="margin: 15px auto; width: fit-content;">
      <lifedi-btn *ngIf="skillTreeForm.valid && nodes.length > 5" lable="สร้าง"
        (click)="createSkillTree(skillTreeForm.value)"
        customStyle="background-color: #005C3D; color: #FFF; width: 100%; margin: 0px; padding: 0 15px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!skillTreeForm.valid || nodes.length <= 5" lable="สร้าง" disabled="true"
        customStyle="color: #FFF; width: 100%; margin: 0px; padding: 0 15px;">
      </lifedi-btn>
    </div>
  </div>
  <div *ngIf="isEdit && !isViewOnly">
    <div class="mt-3 mb-3" style="margin: 15px auto; width: fit-content;">
      <lifedi-btn *ngIf="skillTreeForm?.valid && nodes.length > 5" lable="บันทึก"
        (click)="editSkillTree(skillTreeForm.value)"
        customStyle="background-color: #005C3D; color: #FFF; width: 100%; margin: 0px; padding: 0 15px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!skillTreeForm?.valid || nodes.length <= 5" lable="บันทึก" disabled="true"
        customStyle="color: #FFF; width: 100%; margin: 0px; padding: 0 15px;">
      </lifedi-btn>
    </div>
  </div>
</div>
